export default function hasEmptyString(obj) {
  for (let key in obj) {
    if (obj[key] === "") {
      return true; // Found an empty string value, return true
    }
  }
  return false; // No empty strings found
}
